<template>
  <div>
    <el-dialog
      :title="isEdit ? '编辑' : '创建实物'"
      width="50%"
      :visible.sync="dialogFormVisible"
      destroy-on-close
      @close="close"
    >
      <div class="tips">
        <jd-tips margin="0 0 20px 0">
          <p>1、非官方权益，商家自定义实物奖品信息</p>
          <p>2、线下手动发放</p>
        </jd-tips>
      </div>
      <el-form
        ref="formRef"
        :model="createForm"
        :rules="rules"
        label-width="120px"
      >
        <el-form-item label="商品来源:" required>
          <el-radio-group
            :disabled="isEdit"
            v-model="createForm.goodsSource"
            @change="cleanImg"
          >
            <el-radio :label="0">新建商品</el-radio>
            <el-radio :label="1">从店铺商品复制</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="createForm.goodsSource == 1">
          <el-button :disabled="isEdit" @click="isShowGoodsVisible = true"
            >选择商品</el-button
          >
        </el-form-item>
        <el-form-item label="实物名称:" prop="goodsName">
          <el-input
            v-model="createForm.goodsName"
            maxlength="12"
            show-word-limit
            placeholder="请输入"
            style="width: 340px"
          ></el-input>
        </el-form-item>
        <el-form-item label="内部编号:">
          <el-input
            v-model="createForm.internalNumber"
            style="width: 340px"
            maxlength="12"
            show-word-limit
            placeholder="商家内部使用，可作为发货唯一标识对接发货系统"
          ></el-input>
        </el-form-item>
        <el-form-item label="库存模式:" required>
          <el-radio-group :disabled="isEdit" v-model="createForm.inventoryType" @change="handleInventoryType">
            <el-radio :label="0">限制库存</el-radio>
            <el-radio :label="1">不限库存</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="实物库存:"
          v-if="createForm.inventoryType == 0"
          prop="totalAmount"
        >
          <el-input
            v-model.number="createForm.totalAmount"
            placeholder="请输入"
            style="width: 120px"
            :disabled="isEdit"
            @input="
              createForm.totalAmount = getNumberData(1, $event, 0, 1, 999999)
            "
          ></el-input>
          <span class="margin-style">件</span>
        </el-form-item>
        <el-form-item label="实物图片:" required>
          <div class="upload">
            <el-upload
              ref="upload"
              action="/jd-hd-web/image/upload"
              :class="isHideUpload ? 'hide' : ''"
              list-type="picture-card"
              :file-list="fileList"
              :before-upload="beforeUpload"
              :on-remove="handleRemove"
              :on-success="handleUploadSuccess"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <div class="planImg">
              <div class="planImg-tip">
                <p>图片尺寸：推荐 宽度200px 高度200px</p>
                <p>图片大小：不超过1M，支持JPG、PNG</p>
                <p>用于移动端礼品卡详情页展示</p>
              </div>
              <span class="operation" @click="resetUrl">重置</span>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="实物描述:" prop="descprition">
          <el-input
            type="textarea"
            v-model="createForm.description"
            maxlength="255"
            show-word-limit
            placeholder="请输入"
            style="width: 400px"
          ></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="handleCreateConfirm('formRef')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 选择商品 -->
    <selectShopGoods
      v-if="isShowGoodsVisible"
      :isShowGoodsVisible="isShowGoodsVisible"
      @chooseGoods="handleGetGoods"
    ></selectShopGoods>
  </div>
</template>
<script>
import jdTips from "@/components/common/jdTips.vue";
import selectShopGoods from "./selectShopGoods.vue";
import { createGoods, updateGoods } from "@/api/integralCenter/physical.js";
export default {
  components: {
    selectShopGoods,
    jdTips,
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    dialogFormVisible: {
      type: Boolean,
      default: false,
    },
    editForm: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isHideUpload: true,
      fileList: [
        {
          url:
            "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/physical.png",
          name: "实物卡",
        },
      ],
      isShowGoodsVisible: false,
      createForm: {
        goodsSource: 0,
        skuId: null,
        goodsName: "",
        internalNumber: "",
        inventoryType: 0,
        totalAmount: "",
        image:
          "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/physical.png",
        description: "",
      },
      rules: {
        goodsName: [
          { required: true, message: "请输入实物名称", trigger: "blur" },
          { required: true, message: "请输入实物名称", trigger: "change" },
          { min: 1, max: 12, message: "不能超过 12 个字符", trigger: "blur" },
        ],
        inventoryType: [
          { required: true, message: "请选择库存模式", trigger: "change" },
        ],
        totalAmount: [
          { required: true, message: "请输入实物库存", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    // 是否为自营店铺
    venderType() {
      return this.$store.getters.loginUserInfo.venderType;
    },
  },
  watch: {},
  mounted() {
    if (this.isEdit) {
      this.createForm = JSON.parse(JSON.stringify(this.editForm));
      this.fileList = [
        {
          url: this.createForm.image,
          name: this.createForm.goodsName,
        },
      ];
    }
  },
  methods: {
    handleInventoryType(val) {
      if(val==1) {
        this.createForm.totalAmount = ""
      }
    },
    handleGetGoods(val) {
      if(val) {
        this.createForm.image = val.logo;
        this.createForm.goodsName = val.skuName.substr(0, 12);
        this.createForm.skuId = val.skuId;
        this.createForm.wareId = this.venderType ? val.skuId : val.wareId;
      }
      this.isShowGoodsVisible = false;
      this.fileList = [
        {
          url: val.logo,
          name: this.createForm.goodsName,
        },
      ];
      this.isHideUpload = true;
    },
    //上传图片
    beforeUpload(file, fileList) {
      // 获取当前剩余可上传文件大小
      let surplusSize = 1024 * 1024 * 1;
      // 控制单个文件的上传大小  字节
      if (file.size > surplusSize) {
        this.$message.info("文件上传失败，所有内容大小不超过1M");
        return false;
      }
      let types = [".png", ".jpg"];
      let type = file.name.substring(file.name.lastIndexOf("."));
      if (!types.includes(type)) {
        this.$message.info("所选文件格式不符，请重新选择图片");
        return false;
      }
    },

    handleRemove(file) {
      this.createForm.image = "";
      this.fileList = [];
      this.isHideUpload = false;
    },
    cleanImg() {
      this.createForm.goodsName = "";
      // this.createForm.image = "";
      // this.isHideUpload = false;
      // this.fileList = [];
    },
    handleUploadSuccess(res) {
      if (res.code != 1) {
        this.$message.error(res.messaga);
      } else {
        this.createForm.image = res.data;
        this.isHideUpload = true;
        this.fileList = [
          {
            url: this.createForm.image,
            name: this.createForm.goodsName,
          },
        ];
        this.$message.success("上传图片成功");
      }
    },
    resetUrl() {
      this.isHideUpload = true;
      this.createForm.image =
        "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/physical.png";
      this.fileList = [
        {
          url: this.createForm.image,
          name: this.createForm.goodsName,
        },
      ];
    },
    close() {
      this.$emit("close");
    },
    handleCreateConfirm(formRef) {
      this.$refs[formRef].validate(async (valid) => {
        if (valid) {
          if(!this.createForm.image) {
            return this.$message.warning("请选择实物图片");
          }
          let res = null;
          if (this.isEdit) {
            let params = {
              id: this.createForm.id,
              goodsName: this.createForm.goodsName,
              internalNumber: this.createForm.internalNumber,
              image: this.createForm.image,
              description: this.createForm.description,
              goodsSource: this.createForm.goodsSource,
            };
            res = await updateGoods(params);
          } else {
            if (this.createForm.totalAmount) {
              this.createForm.totalAmount = Number(this.createForm.totalAmount);
            }
            res = await createGoods(this.createForm);
          }
          if (res.code == 1) {
            let tip = this.isEdit ? "实物修改成功" : "实物创建成功";
            this.$message.success(tip);
            this.$emit("handleCreateSuccess", false);
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.margin-style {
  margin-left: 8px;
}
.upload {
  display: flex;
  align-items: center;
  /deep/.el-upload--picture-card {
    width: 100px;
    height: 100px;
    line-height: 107px;
  }
  /deep/.el-upload-list--picture-card .el-upload-list__item {
    width: 100px;
    height: 100px;
  }
  .planImg {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-left: 8px;
    &-tip {
      color: #999999;
      font-size: 12px;
      line-height: 20px;
    }
    .operation {
      cursor: pointer;
      color: #7f85e9;
      &:hover {
        color: #7b61ff;
      }
    }
  }
}
.tips {
  margin-bottom: 16px;
}
.hide ::v-deep .el-upload--picture-card {
  display: none;
}
</style>
